import React from "react";
import {Form, Input , Radio} from 'antd';
import NHFormItem from "../../common/NHFormItem";

const FormItem = Form.Item;

const baseUrlPath = "/schoolMng"; //学校信息管理模块路径

/**
 * 快速导航查看表单
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const {form,initFormData,zt0,zt1} = this.props;
        console.log(initFormData);
        return (
            <form>
                <NHFormItem  label={"链接名称"}
                            form={form}>
                    <span>{initFormData.LJMC}</span>
                </NHFormItem>
                <NHFormItem  label={"链接地址"}
                            form={form}>
                    <span>{initFormData.LJDZ}</span>
                </NHFormItem>
                <NHFormItem id={"ljlx"} label={"链接类别"}
                            form={form}>
                    <span>{initFormData.LJLXMC}</span>
                </NHFormItem>
                <NHFormItem id={"pxh"} label={"排序号"}
                            form={form}>
                    <span>{initFormData.PXH}</span>
                </NHFormItem>
                <NHFormItem id={"zt"} label={"状态"}
                            form={form}>
                    <span>{initFormData.ZT=='1'?zt1:zt0}</span>
                </NHFormItem>
            </form>
        );
    }
}
const viewForm = Form.create()(ViewForm);

export default viewForm;



// WEBPACK FOOTER //
// ./components/fwwgl/ksdh/ViewForm.js